import React, { useEffect, useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Form, Row, Col, InputGroup, FormText, Card } from "react-bootstrap";
import FileUpload from "../../components/Attachment/Attachment";
import { IconFileDescription } from "@tabler/icons-react";
import useIdleLogout from "../../hooks/useIdleLogout";

function BugForm({ isEditing, attachmnetid }) {
  const {
    control,
    watch,
    setValue,
    register,
    formState: { errors },
  } = useFormContext();

  useIdleLogout();
  
  return (
    <>
      <div className="bug_head">
        <Card.Title className="mb-2"><b>Report a Bug</b> </Card.Title>
        <Card.Subtitle className="mb-2 text-muted">Help us improve our application by reporting any issues you encounter.</Card.Subtitle>
      </div>
      <Row>
        <Col xs={6}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Title</Form.Label>
            <InputGroup>
              <Form.Control
                disabled={isEditing}
                name="bug_title"
                {...register("bug_title")}
                placeholder="Enter bug title"
              />
            </InputGroup>
            {errors.bug_title && (
              <span className="text-danger">{errors.bug_title.message}</span>
            )}
          </Form.Group>
        </Col>
        <Col xs={6}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Priority</Form.Label>
            <InputGroup>
              <Form.Select
                {...register("priority_type", {
                  required: "Payment Type is required",
                })}
              >
                <option value="">Select Priority</option>
                <option value="LOW">Low</option>
                <option value="MEDIUM">Medium</option>
                <option value="HIGH">High</option>
                <option value="CRITICAL">Critical</option>
              </Form.Select>
            </InputGroup>
            {errors.priority_type && (
              <span className="text-danger">
                {errors.priority_type.message}
              </span>
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Description</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconFileDescription stroke={1} />
              </InputGroup.Text>
              <Form.Control
                as="textarea"
                name="Enter description"
                {...register("description")}
                style={{
                  height: "auto",
                  minHeight: "80px",
                  resize: "none",
                }}
                onInput={(e) => {
                  e.target.style.height = "auto";
                  e.target.style.height = `${e.target.scrollHeight}px`;
                }}
                placeholder="Enter description"
              />
            </InputGroup>
            {errors.description && (
              <span className="text-danger">{errors.description.message}</span>
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Form.Group>
            <Form.Label>Steps To Reproduce</Form.Label>
            <InputGroup className="mb-3">
              <InputGroup.Text>
                <IconFileDescription stroke={1} />
              </InputGroup.Text>
              <Form.Control
                as="textarea"
                name="Enter description"
                {...register("stepsReproduce")}
                style={{
                  height: "auto",
                  minHeight: "80px",
                  resize: "none",
                }}
                onInput={(e) => {
                  e.target.style.height = "auto";
                  e.target.style.height = `${e.target.scrollHeight}px`;
                }}
                placeholder="Enter steps to reproduce"
              />
            </InputGroup>
            {errors.stepsReproduce && (
              <span className="text-danger">
                {errors.stepsReproduce.message}
              </span>
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <Form.Group>
            <Form.Label>Expected Behavior</Form.Label>
            <InputGroup className="mb-3">
              <Form.Control
                as="textarea"
                name="Enter description"
                {...register("expectedBehaviour")}
                style={{
                  height: "auto",
                  minHeight: "80px",
                  resize: "none",
                }}
                onInput={(e) => {
                  e.target.style.height = "auto";
                  e.target.style.height = `${e.target.scrollHeight}px`;
                }}
                placeholder="Enter the expected behavior here"
              />
            </InputGroup>
            {errors.expectedBehaviour && (
              <span className="text-danger">
                {errors.expectedBehaviour.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col xs={6}>
          <Form.Group>
            <Form.Label>Actual Behavior</Form.Label>
            <InputGroup className="mb-3">
              <Form.Control
                as="textarea"
                name="Enter description"
                {...register("actualBehaviour")}
                style={{
                  height: "auto",
                  minHeight: "80px",
                  resize: "none",
                }}
                onInput={(e) => {
                  e.target.style.height = "auto";
                  e.target.style.height = `${e.target.scrollHeight}px`;
                }}
                placeholder="Enter the actual behavior here"
              />
            </InputGroup>
            {errors.actualBehaviour && (
              <span className="text-danger">
                {errors.actualBehaviour.message}
              </span>
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Form.Group>
            <Form.Label>Browser/Environment Details</Form.Label>
            <InputGroup className="mb-3">
              <InputGroup.Text>
                <IconFileDescription stroke={1} />
              </InputGroup.Text>
              <Form.Control
                as="textarea"
                name="Enter description"
                {...register("browserDetails")}
                style={{
                  height: "auto",
                  minHeight: "80px",
                  resize: "none",
                }}
                onInput={(e) => {
                  e.target.style.height = "auto";
                  e.target.style.height = `${e.target.scrollHeight}px`;
                }}
                placeholder="Enter your environment details"
              />
            </InputGroup>
            {errors.browserDetails && (
              <span className="text-danger">
                {errors.browserDetails.message}
              </span>
            )}
          </Form.Group>
        </Col>
      </Row>
      <FileUpload moduleType={"BUG"} attachmnetid={attachmnetid} />
    </>
  );
}

export default BugForm;
